export default __webpack_public_path__ + "static/media/255.cc5cd66a.png";